module.exports = __webpack_public_path__ + "img/green_018.7979af48.png";